import styled from "styled-components";

// Tela ADMIN (superfície clara): as cores vêm do tema admin, não do comum.
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral.black};
`;

export const Empty = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.neutral.gray6};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    text-align: left;
    padding: 8px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray2};
    color: ${({ theme }) => theme.colors.neutral.black};
  }

  th {
    font-weight: 600;
    white-space: nowrap;
  }
`;
